import isApiError from "@insite/client-framework/Common/isApiError";
import {
    createHandlerChainRunnerOptionalParameter,
    HasOnError,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { GetAccessioralParam, getAccessorials, getShipViaAccessorials } from "@tKgpco/Services/AccessorialsService";
import { CustomApiHandler } from "@tKgpco/Store/CustomHandlerCreator";
import { AccessorialState, CarrierShipViaAccesorial } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";

export interface shipViaInterface {
    shipViaId?: string;
}

type Parameters = GetAccessioralParam & HasOnSuccess & HasOnError;
type HandlerType = CustomApiHandler<Parameters, CarrierShipViaAccesorial>;

export const BeginLoadAccessorials: HandlerType = props => {
    props.dispatch({ type: "Custom/Accessorials/BeginLoad" });
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getShipViaAccessorials(props.parameter);
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.parameter.onError?.(error.errorJson.message);
            return false;
        }
        throw error;
    }
};

export const CompleteLoadAccessorials: HandlerType = props => {
    props.dispatch({
        type: "Custom/CarrierShipViaAccessorials/CompleteLoad",
        accessorials: props.apiResult,
    });
};

export const chain = [BeginLoadAccessorials, RequestDataFromApi, CompleteLoadAccessorials];

const loadShipViaAccessorials = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        carrierId: "",
        shipViaId: "",
    },
    "loadShipViaAccessorials",
);
export default loadShipViaAccessorials;
